// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Inventoryless_pageWrap__U\\+WAJ {
  padding: 4px 4px 32px;
}

.Inventoryless_statBadge__raV2u {
  background: #F5F3FE;
  color: #4c2fb3;
  padding: 10px 18px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13.5px;
}

/* =========================================================
   AntD Table premium override
   ========================================================= */
.Inventoryless_tableWrap__Zx3AE .ant-table {
  border-radius: 12px;
}
.Inventoryless_tableWrap__Zx3AE .ant-table-thead > tr > th {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;
  color: #ede9fb !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  border-bottom: 1px solid #5b3fc8 !important;
}
.Inventoryless_tableWrap__Zx3AE .ant-table-thead > tr > th::before {
  display: none !important;
}
.Inventoryless_tableWrap__Zx3AE .ant-table-tbody > tr > td {
  font-size: 13px;
  color: #1f2937;
  border-bottom: 1px solid #eef0f3 !important;
}
.Inventoryless_tableWrap__Zx3AE .ant-table-tbody > tr:hover > td {
  background: #f8fafc !important;
}
.Inventoryless_tableWrap__Zx3AE .ant-pagination-item-active {
  border-color: #4c2fb3 !important;
}
.Inventoryless_tableWrap__Zx3AE .ant-pagination-item-active a {
  color: #4c2fb3 !important;
}

.Inventoryless_modalTableWrap__OZbmD .ant-table-thead > tr > th {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;
  color: #ede9fb !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  text-transform: uppercase;
  letter-spacing: 0.14em;
}

.Inventoryless_iconBtn__yA3RO {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #F5F3FE;
  color: #4c2fb3;
  cursor: pointer;
  transition: background 0.15s ease;
}
.Inventoryless_iconBtn__yA3RO:hover {
  background: #E7DEFB;
}

.Inventoryless_acceptBtn__ie\\+nA {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: #ffffff;
  border: none;
  padding: 10px 24px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13.5px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(22, 163, 74, 0.22);
}

.Inventoryless_rejectBtn__1ZFmH {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: #ffffff;
  border: none;
  padding: 10px 24px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13.5px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(220, 38, 38, 0.22);
}

.Inventoryless_submitBtn__0vstf {
  background: linear-gradient(135deg, #4c2fb3, #7c5cfc);
  color: #ffffff;
  border: none;
  padding: 12px 30px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13.5px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);
}

.Inventoryless_bidField__77jSC {
  margin-bottom: 18px;
}

.Inventoryless_bidLabel__tLihS {
  font-weight: 600;
  margin-bottom: 8px;
  color: #374151;
  font-size: 13.5px;
}

.Inventoryless_bidInput__-VH9\\+ {
  height: 44px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  padding: 0 14px;
  font-size: 13.5px;
  width: 100%;
}
.Inventoryless_bidInput__-VH9\\+:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.Inventoryless_modalBody__tEW-u {
  background: #FAFAFC;
  padding: 16px;
  border-radius: 12px;
}

/* =========================================================
   Filters / search / toggles
   ========================================================= */
.Inventoryless_filterRow__jLbhz {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 4px;
}

.Inventoryless_chip__4BiS0 {
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid #E5E7EB;
  background: #fff;
  color: #4B5563;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.15s ease;
}

.Inventoryless_chip__4BiS0:hover {
  border-color: #7c5cfc;
}

.Inventoryless_chipActive__Kuv6n {
  background: #F5F3FE;
  border-color: #4c2fb3;
  color: #4c2fb3;
}

.Inventoryless_searchWrap__TgqNv {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 4px 12px;
  min-width: 260px;
  background: #fff;
  color: #9CA3AF;
}

.Inventoryless_priceBreakupLink__zVKDj {
  color: #4c2fb3;
  font-weight: 600;
  font-size: 12.5px;
  cursor: pointer;
  text-decoration: underline;
}

.Inventoryless_comingSoonWrap__6aBZj {
  padding: 64px 24px;
  text-align: center;
}

.Inventoryless_comingSoonTitle__d3Dhp {
  font-size: 18px;
  font-weight: 700;
  color: #1F2430;
}

.Inventoryless_comingSoonText__WEHsc {
  color: #6B7280;
  font-size: 13.5px;
  margin-top: 6px;
}

.Inventoryless_breakupCard__ve3nl {
  background: #FAFAFC;
  border: 1px solid #EEF0F3;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
}

.Inventoryless_breakupRow__rLwqF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.Inventoryless_breakupLabel__KGJ5G {
  color: #6B7280;
  font-size: 13px;
}

.Inventoryless_breakupValue__Y0Cyx {
  color: #1F2430;
  font-weight: 600;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Invenrtyless/Inventoryless.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;8DAE8D;AAC9D;EACE,mBAAmB;AACrB;AACA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.statBadge {\n  background: #F5F3FE;\n  color: #4c2fb3;\n  padding: 10px 18px;\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 13.5px;\n}\n\n/* =========================================================\n   AntD Table premium override\n   ========================================================= */\n.tableWrap :global(.ant-table) {\n  border-radius: 12px;\n}\n.tableWrap :global(.ant-table-thead > tr > th) {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;\n  color: #ede9fb !important;\n  font-weight: 600 !important;\n  font-size: 11px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  border-bottom: 1px solid #5b3fc8 !important;\n}\n.tableWrap :global(.ant-table-thead > tr > th)::before {\n  display: none !important;\n}\n.tableWrap :global(.ant-table-tbody > tr > td) {\n  font-size: 13px;\n  color: #1f2937;\n  border-bottom: 1px solid #eef0f3 !important;\n}\n.tableWrap :global(.ant-table-tbody > tr:hover > td) {\n  background: #f8fafc !important;\n}\n.tableWrap :global(.ant-pagination-item-active) {\n  border-color: #4c2fb3 !important;\n}\n.tableWrap :global(.ant-pagination-item-active a) {\n  color: #4c2fb3 !important;\n}\n\n.modalTableWrap :global(.ant-table-thead > tr > th) {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;\n  color: #ede9fb !important;\n  font-weight: 600 !important;\n  font-size: 11px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n}\n\n.iconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.iconBtn:hover {\n  background: #E7DEFB;\n}\n\n.acceptBtn {\n  background: linear-gradient(135deg, #22c55e, #16a34a);\n  color: #ffffff;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 13.5px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(22, 163, 74, 0.22);\n}\n\n.rejectBtn {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: #ffffff;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 13.5px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(220, 38, 38, 0.22);\n}\n\n.submitBtn {\n  background: linear-gradient(135deg, #4c2fb3, #7c5cfc);\n  color: #ffffff;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 13.5px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);\n}\n\n.bidField {\n  margin-bottom: 18px;\n}\n\n.bidLabel {\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #374151;\n  font-size: 13.5px;\n}\n\n.bidInput {\n  height: 44px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  padding: 0 14px;\n  font-size: 13.5px;\n  width: 100%;\n}\n.bidInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.modalBody {\n  background: #FAFAFC;\n  padding: 16px;\n  border-radius: 12px;\n}\n\n/* =========================================================\n   Filters / search / toggles\n   ========================================================= */\n.filterRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 14px 4px;\n}\n\n.chip {\n  padding: 6px 16px;\n  border-radius: 20px;\n  border: 1px solid #E5E7EB;\n  background: #fff;\n  color: #4B5563;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.15s ease;\n}\n\n.chip:hover {\n  border-color: #7c5cfc;\n}\n\n.chipActive {\n  background: #F5F3FE;\n  border-color: #4c2fb3;\n  color: #4c2fb3;\n}\n\n.searchWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  padding: 4px 12px;\n  min-width: 260px;\n  background: #fff;\n  color: #9CA3AF;\n}\n\n.priceBreakupLink {\n  color: #4c2fb3;\n  font-weight: 600;\n  font-size: 12.5px;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.comingSoonWrap {\n  padding: 64px 24px;\n  text-align: center;\n}\n\n.comingSoonTitle {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1F2430;\n}\n\n.comingSoonText {\n  color: #6B7280;\n  font-size: 13.5px;\n  margin-top: 6px;\n}\n\n.breakupCard {\n  background: #FAFAFC;\n  border: 1px solid #EEF0F3;\n  border-radius: 12px;\n  padding: 14px 16px;\n  margin-bottom: 14px;\n}\n\n.breakupRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.breakupLabel {\n  color: #6B7280;\n  font-size: 13px;\n}\n\n.breakupValue {\n  color: #1F2430;\n  font-weight: 600;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `Inventoryless_pageWrap__U+WAJ`,
	"statBadge": `Inventoryless_statBadge__raV2u`,
	"tableWrap": `Inventoryless_tableWrap__Zx3AE`,
	"modalTableWrap": `Inventoryless_modalTableWrap__OZbmD`,
	"iconBtn": `Inventoryless_iconBtn__yA3RO`,
	"acceptBtn": `Inventoryless_acceptBtn__ie+nA`,
	"rejectBtn": `Inventoryless_rejectBtn__1ZFmH`,
	"submitBtn": `Inventoryless_submitBtn__0vstf`,
	"bidField": `Inventoryless_bidField__77jSC`,
	"bidLabel": `Inventoryless_bidLabel__tLihS`,
	"bidInput": `Inventoryless_bidInput__-VH9+`,
	"modalBody": `Inventoryless_modalBody__tEW-u`,
	"filterRow": `Inventoryless_filterRow__jLbhz`,
	"chip": `Inventoryless_chip__4BiS0`,
	"chipActive": `Inventoryless_chipActive__Kuv6n`,
	"searchWrap": `Inventoryless_searchWrap__TgqNv`,
	"priceBreakupLink": `Inventoryless_priceBreakupLink__zVKDj`,
	"comingSoonWrap": `Inventoryless_comingSoonWrap__6aBZj`,
	"comingSoonTitle": `Inventoryless_comingSoonTitle__d3Dhp`,
	"comingSoonText": `Inventoryless_comingSoonText__WEHsc`,
	"breakupCard": `Inventoryless_breakupCard__ve3nl`,
	"breakupRow": `Inventoryless_breakupRow__rLwqF`,
	"breakupLabel": `Inventoryless_breakupLabel__KGJ5G`,
	"breakupValue": `Inventoryless_breakupValue__Y0Cyx`
};
export default ___CSS_LOADER_EXPORT___;
